const baseOptions = [
  {
    name: "title",
    type: "Section",
    fields: [
      {
        name: "title",
        type: "String",
      },
      {
        name: "titlePosition",
        options: ['in', 'out', 'none'],
        type: "list",
      },
    ],
  },
  {
    name: "titleTextStyle",
    type: "Object",
    fields: [
      {
        name: "color",
        type: "String",
      },
      {
        name: "fontSize",
        type: "Int",
      },
      {
        name: "bold",
        type: "Boolean",
      },
      {
        name: "italic",
        type: "Boolean",
      },
    ],
  },
  {
    name: "Color",
    type: "Section",
    fields: [
      {
        name: "backgroundColor",
        type: "String",
      },
      {
        name: "chartArea.backgroundColor",
        type: "String",
      },
      {
        name: "colors",
        type: "Array",
      },
    ],
  },
  {
    name: "Axis Titles",
    type: "Section",
    fields: [
      {
        name: "axisTitlesPosition",
        type: "list",
        options: ['in', 'out', 'none'],
      },
      {
        name: "vAxis.title",
        type: "String",
      },
      {
        name: "hAxis.title",
        type: "String",
      },
    ],
  },
  {
    name: "General",
    type: "Section",
    fields: [
      {
        name: "lineWidth",
        type: "Int",
      },
      {
        name: "orientation",
        type: "list",
        options: ['vertical', 'horizontal'],
      },
      {
        name: "focusTarget",
        type: "list",
        options: ['datum', 'category'],
      },
      {
        name: "isStacked",
        type: "Boolean",
      },
      {
        name: "areaOpacity",
        type: "Int",
      },
      {
        name: "theme",
        type: "list",
        options: ['maximized', 'none'],
      },
      {
        name: "seriesType",
        type: "list",
        options: ['line', 'area', 'bars', 'candlesticks', 'steppedArea'],
      },
    ],
  },
  {
    name: "Points",
    type: "Section",
    fields: [
      {
        name: "pointShape",
        type: "list",
        options: ['circle', 'triangle', 'square', 'diamond', 'star', 'polygon'],
      },
      {
        name: "pointSize",
        type: "Int",
      },
      {
        name: "pointsVisible",
        type: "Boolean",
      },
    ],
  },
];

const options = [
  {
    name: "backgroundColor",
    type: "Object",
    fields: [
      {
        name: "stroke",
        type: "String",
      },
      {
        name: "strokeWidth",
        type: "Int",
      },
      {
        name: "fill",
        type: "String",
      },
    ],
  },
  {
    name: "chartArea",
    primitive: false,
    type: "Object",
    fields: [
      {
        name: "left",
        primitive: true,
        type: "String",
        default: "auto",
      },
      {
        name: "top",
        primitive: true,
        type: "String",
        default: "auto",
      },
      {
        name: "width",
        primitive: true,
        type: "String",
        default: "auto",
      },
      {
        name: "height",
        primitive: true,
        type: "String",
        default: "auto",
      },
    ],
  },
  {
    name: "crosshair",
    type: "Object",
    fields: [
      {
        name: "color",
        type: "String",
      },
      {
        name: "opacity",
        type: "Int",
      },
      {
        name: "orientation",
        type: "list",
        options: ['both', 'vertical', 'horizontal'],
      },
      {
        name: "trigger",
        type: "list",
        options: ['both', 'focus', 'selection'],
      },
    ],
  },
  {
    name: "legend",
    primitive: false,
    type: "Object",
    fields: [
      {
        name: "pageIndex",
        primitive: true,
        type: "Int",
        default: "0",
      },
      {
        name: "position",
        primitive: true,
        type: "list",
        options: ['bottom', 'left', 'in', 'none', 'right', 'top'],
      },
      {
        name: "alignment",
        primitive: true,
        type: "list",
        options: ['start', 'center', 'end'],
      },
    ],
  },
  {
    name: "Data",
    type: "Section",
    fields: [
      {
        name: "dataOpacity",
        type: "Int",
      },
      {
        name: "interpolateNulls",
        type: "Boolean",
      },
      {
        name: "isStacked",
        type: "list",
        options: ['percent', 'relative', 'absolute'],
      },
      {
        name: "reverseCategories",
        type: "Boolean",
      },
    ],
  },
  {
    name: "Font",
    type: "Section",
    fields: [
      {
        name: "fontSize",
        type: "Int",
      },
      {
        name: "fontName",
        type: "String",
      },
    ],
  },
  {
    name: "hAxis",
    type: "Section",
    fields: [
      {
        name: "baseline",
        type: "Int",
      },
      {
        name: "baselineColor",
        type: "String",
      },
      {
        name: "direction",
        type: "list",
        options: [1, -1],
      },
      {
        name: "format",
        type: "list",
        options: ['none', 'decimal', 'scientific', 'currency', 'percent', 'short', 'long'],
      },
      {
        name: "textPosition",
        type: "list",
        options: ['out', 'in', 'none'],
      },
      {
        name: "maxValue",
        type: "Int",
      },
      {
        name: "minValue",
        type: "Int",
      },
    ],
  },
  {
    name: "Tooltip",
    type: "Section",
    fields: [
      {
        name: "aggregationTarget",
        type: "list",
        options: ['category', 'series', 'auto', 'none'],
      },
      {
        name: "tooltip.trigger",
        type: "list",
        options: ['focus', 'none', 'selection'],
      },
      {
        name: "selectionMode",
        type: "list",
        options: ['single', 'multiple'],
      },
    ],
  },
  {
    name: "vAxis",
    type: "Section",
    fields: [
      {
        name: "baseline",
        type: "Int",
      },
      {
        name: "baselineColor",
        type: "String",
      },
      {
        name: "direction",
        type: "list",
        options: [1, -1],
      },
      {
        name: "format",
        type: "list",
        options: ['none', 'decimal', 'scientific', 'currency', 'percent', 'short', 'long'],
      },
      {
        name: "textPosition",
        type: "list",
        options: ['out', 'in', 'none'],
      },
      {
        name: "maxValue",
        type: "Int",
      },
      {
        name: "minValue",
        type: "Int",
      },
    ],
  },
];

export default {
  baseOptions,
  options,
};
